import React, { useEffect, useState } from "react";
import { Card, Row, Col, Spinner, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";

const SHEET_URL = 'https://opensheet.elk.sh/11R9T54CjmC2RFZuvmD7fxElItomKuvfTb9t5nHjeWNU/Courses';

const CoursesList = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(SHEET_URL)
      .then(res => res.json())
      .then(data => {
        setCourses(data);
        setLoading(false);
      });
  }, []);

  if (loading) return <Spinner animation="border" />;

  // Group courses by Term
  const groupedByTerm = courses.reduce((acc, course) => {
    const term = course.Term || "Unknown Term";
    if (!acc[term]) acc[term] = [];
    acc[term].push(course);
    return acc;
  }, {});

  // Natural sort terms like "Year-1-Term-2"
  const termKeys = Object.keys(groupedByTerm).sort((a, b) => {
    const termRegex = /Year-(\d+)-Term-(\d+)/i;
    const matchA = a.match(termRegex);
    const matchB = b.match(termRegex);

    if (matchA && matchB) {
      const yearDiff = parseInt(matchA[1]) - parseInt(matchB[1]);
      if (yearDiff !== 0) return yearDiff;
      return parseInt(matchA[2]) - parseInt(matchB[2]);
    }
    return a.localeCompare(b);
  });

  // Latest term is the last one after sorting
  const latestTerm = termKeys[termKeys.length - 1];

  return (
    <>
      <style>{`
        .force-margin { margin-top: 66px !important; }
      `}</style>
      <div>
        <h2 className="mb-4 force-margin">Available Courses</h2>

        <Accordion defaultActiveKey={latestTerm}>
          {termKeys.map((term) => (
            <Accordion.Item eventKey={term} key={term}>
              <Accordion.Header>{term}</Accordion.Header>
              <Accordion.Body>
                <Row>
                  {groupedByTerm[term].map((course) => (
                    <Col md={6} lg={4} key={course.CourseId} className="mb-4">
                      <Card>
                        <Card.Body>
                          <Card.Title>{course.CourseName}</Card.Title>
                          <Card.Subtitle className="mb-2 text-muted">
                            {course.Faculty}
                          </Card.Subtitle>
                          <Card.Text>
                            <strong>Email:</strong> {course.FacultyEmail || 'N/A'}<br />
                            <strong>Drive:</strong>{" "}
                            {course.GoogleDriveFolder ? (
                              <a href={course.GoogleDriveFolder} target="_blank" rel="noopener noreferrer">
                                View Folder
                              </a>
                            ) : 'N/A'}
                            <br />
                            <strong>Faculty Materials:</strong>{" "}
                            {course.FacultyMaterials ? (
                              <a href={course.FacultyMaterials} target="_blank" rel="noopener noreferrer">
                                View Materials
                              </a>
                            ) : 'N/A'}
                          </Card.Text>
                          <Link to={`/course/${course.CourseId}`} className="btn btn-primary">
                            View Course
                          </Link>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </>
  );
};

export default CoursesList;
